import Vue from 'vue'
import VueRouter, { Route, RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'

const titleModule = getModule(TitleModule)

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/:id?',
    name: 'home',
    component: Home,
    meta: { title: 'Investigations', requiresAuth: true },
    props: true
  },
  {
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/Login.vue'),
    meta: { title: 'Comet Expert Extensions' }
  },
  {
    path: '/investigation/:id',
    name: 'investigation',
    component: () => import('@/views/Investigation.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/root-causes/:id',
    name: 'rootCauses',
    component: () => import('@/views/RootCauses.vue'),
    meta: { title: 'Root Causes', requiresAuth: true },
    props: true
  },
  {
    path: '/stage/:stage/:id',
    name: 'stage',
    component: () => import('@/views/Stage.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/suggested-actions/:id',
    name: 'suggestedActions',
    component: () => import('@/views/SuggestedActions.vue'),
    meta: { title: 'Suggested Actions', requiresAuth: true },
    props: true
  },
  {
    path: '/suggested-action/:id',
    name: 'suggestedAction',
    component: () => import('@/views/SuggestedAction.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/admin/user/:id',
    name: 'user-admin',
    component: () => import('@/views/UserAdmin.vue'),
    meta: { title: 'User', requiresAuth: true },
    props: true
  },
  {
    path: '/admin/extensions',
    name: 'extensions',
    component: () => import('@/views/Extensions.vue'),
    meta: { title: 'Extensions', requiresAuth: true }
  },
  {
    path: '/extension-admin/:id',
    name: 'extension-admin',
    component: () => import('@/views/ExtensionAdmin.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/extension-info/:stage/:id',
    name: 'extensionInfo',
    component: () => import('@/views/ExtensionInfo.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/stage-admin/:stage',
    name: 'stage-admin',
    component: () => import('@/views/StageAdmin.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/stage-info-admin/:stage',
    name: 'stage-info-admin',
    component: () => import('@/views/StageInfoAdmin.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/findings/:id',
    name: 'findings',
    component: () => import('@/views/Findings.vue'),
    meta: { title: 'Findings', requiresAuth: true },
    props: true
  },
  {
    path: '/prompts-admin/:id',
    name: 'prompts-admin',
    component: () => import('@/views/PromptsAdmin.vue'),
    meta: { title: 'Prompts', requiresAuth: true },
    props: true
  },
  {
    path: '/prompt-admin/:id',
    name: 'edit-prompt',
    component: () => import('@/views/PromptAdmin.vue'),
    meta: { title: 'Edit Prompt', requiresAuth: true },
    props: true
  },
  {
    path: '/password-reset/:id',
    name: 'passwordReset',
    component: () => import('@/views/PasswordReset.vue'),
    props: true,
    meta: { requiresAuth: false, title: 'Reset Password' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to: Route, from: Route, next: Function) => {
  const user: string | null = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {
      next({ name: 'login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    if (user) {
      next({
        name: 'home',
        query: { redirect: to.fullPath }
      })
      return
    } else {
      next()
    }
  }

  if (to.meta.title) {
    titleModule.setPageTitle(to.meta.title)
  }
})

export default router
